import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AnalyticsService } from '@core/services';
import { MbSwitchModule } from '@am/moebius';

@Component({
    selector: 'refundable-rate',
    templateUrl: './refundable-rate.component.html',
    styleUrls: ['./refundable-rate.component.scss'],
    standalone: true,
    imports: [MbSwitchModule],
})
export class RefundableRateComponent implements OnInit {
  @Input()
  refundableRateSelected: boolean;
  @Output()
  refundableRateChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {}

  public setRate() {
    if (this.refundableRateSelected) {
      this.analyticsService.trackEvent({
        section: 'Detail',
        action: 'Refundable Rooms',
        label: 'Click',
      });
    } else {
      this.analyticsService.trackEvent({
        section: 'Detail',
        action: 'Refundable Rooms',
        label: 'Remove',
      });
    }
    this.refundableRateChange.emit(!this.refundableRateSelected);
  }
}
